<template>
  <div class="works-component comfort-zone">
    <div class="banner"> 
      <img src="../../../assets/img/works/link-house-condo/02-舒窝 -COMFORT ZONE -SUNWAY MONT- MONT KIARA/00-hero banner.jpg" alt="">
    </div>
    <div class="border-bottom-white-1px">
      <div class="container ">
        <p class="playfair playfair-display-sm-400 white text-left m-0">
          舒窝 | Comfort Zone
        </p>
      </div>
    </div>
    <div class="container p-112 works-img border-bottom-white-1px">
      <b-row sm>
        <b-col md="4" sm>
          <img src="../../../assets/img/works/link-house-condo/02-舒窝 -COMFORT ZONE -SUNWAY MONT- MONT KIARA/01-portrait-1.jpg" alt="">
        </b-col>
        <b-col md="4" sm>
          <img src="../../../assets/img/works/link-house-condo/02-舒窝 -COMFORT ZONE -SUNWAY MONT- MONT KIARA/01-portrait-2.jpg" alt="">
        </b-col>
        <b-col md="4" sm>
          <img src="../../../assets/img/works/link-house-condo/02-舒窝 -COMFORT ZONE -SUNWAY MONT- MONT KIARA/01-portrait-3.jpg" alt="">
        </b-col>
      </b-row>
      <b-row sm>
        <b-col md="6" sm>
          <img src="../../../assets/img/works/link-house-condo/02-舒窝 -COMFORT ZONE -SUNWAY MONT- MONT KIARA/02-land-1.jpg" alt="">
        </b-col>
        <b-col md="6" sm>
          <img src="../../../assets/img/works/link-house-condo/02-舒窝 -COMFORT ZONE -SUNWAY MONT- MONT KIARA/02-land-2.jpg" alt="">
        </b-col>
      </b-row>
      <b-row sm>
        <b-col>
          <img src="../../../assets/img/works/link-house-condo/02-舒窝 -COMFORT ZONE -SUNWAY MONT- MONT KIARA/03-full-1.jpg" alt="">
        </b-col> 
      </b-row>
      <b-row sm>
        <b-col md="6" sm>
          <img src="../../../assets/img/works/link-house-condo/02-舒窝 -COMFORT ZONE -SUNWAY MONT- MONT KIARA/04-land-1.jpg" alt="">
        </b-col>
        <b-col md="6" sm>
          <img src="../../../assets/img/works/link-house-condo/02-舒窝 -COMFORT ZONE -SUNWAY MONT- MONT KIARA/04-land-2.jpg" alt="">
        </b-col>
      </b-row>
      <b-row sm>
        <b-col md="4" sm>
          <img src="../../../assets/img/works/link-house-condo/02-舒窝 -COMFORT ZONE -SUNWAY MONT- MONT KIARA/05-land-1.jpg" alt="">
        </b-col>
        <b-col md="4" sm>
          <img src="../../../assets/img/works/link-house-condo/02-舒窝 -COMFORT ZONE -SUNWAY MONT- MONT KIARA/05-land-2.jpg" alt="">
        </b-col>
        <b-col md="4" sm>
          <img src="../../../assets/img/works/link-house-condo/02-舒窝 -COMFORT ZONE -SUNWAY MONT- MONT KIARA/05-land-3.jpg" alt="">
        </b-col>
      </b-row> 
      <b-row sm>
        <b-col md="6" sm>
          <img src="../../../assets/img/works/link-house-condo/02-舒窝 -COMFORT ZONE -SUNWAY MONT- MONT KIARA/06-portrait-1.jpg" alt="">
        </b-col>
        <b-col md="6" sm>
          <img src="../../../assets/img/works/link-house-condo/02-舒窝 -COMFORT ZONE -SUNWAY MONT- MONT KIARA/06-portrait-2.jpg" alt="">
        </b-col> 
      </b-row>
      <b-row sm>
        <b-col md="4" sm>
          <img src="../../../assets/img/works/link-house-condo/02-舒窝 -COMFORT ZONE -SUNWAY MONT- MONT KIARA/07-land-1.jpg" alt="">
        </b-col>
        <b-col md="4" sm>
          <img src="../../../assets/img/works/link-house-condo/02-舒窝 -COMFORT ZONE -SUNWAY MONT- MONT KIARA/07-land-2.jpg" alt="">
        </b-col>
        <b-col md="4" sm>
          <img src="../../../assets/img/works/link-house-condo/02-舒窝 -COMFORT ZONE -SUNWAY MONT- MONT KIARA/07-land-3.jpg" alt="">
        </b-col>
      </b-row>  
      <b-row sm>
        <b-col>
          <img src="../../../assets/img/works/link-house-condo/02-舒窝 -COMFORT ZONE -SUNWAY MONT- MONT KIARA/08-full-1.jpg" alt="">
        </b-col>
      </b-row>
      
      <b-row sm>
        <b-col md="6" sm>
          <img src="../../../assets/img/works/link-house-condo/02-舒窝 -COMFORT ZONE -SUNWAY MONT- MONT KIARA/09-land-1.jpg" alt="">
        </b-col>
        <b-col md="6" sm>
          <img src="../../../assets/img/works/link-house-condo/02-舒窝 -COMFORT ZONE -SUNWAY MONT- MONT KIARA/09-land-2.jpg" alt="">
        </b-col>
      </b-row>
      <b-row sm>
        <b-col md="4" sm>
          <img src="../../../assets/img/works/link-house-condo/02-舒窝 -COMFORT ZONE -SUNWAY MONT- MONT KIARA/10-land-1.jpg" alt="">
        </b-col>
        <b-col md="4" sm>
          <img src="../../../assets/img/works/link-house-condo/02-舒窝 -COMFORT ZONE -SUNWAY MONT- MONT KIARA/10-land-2.jpg" alt="">
        </b-col>
        <b-col md="4" sm>
          <img src="../../../assets/img/works/link-house-condo/02-舒窝 -COMFORT ZONE -SUNWAY MONT- MONT KIARA/10-land-3.jpg" alt="">
        </b-col>
      </b-row>   
      <b-row sm>
        <b-col>
          <img src="../../../assets/img/works/link-house-condo/02-舒窝 -COMFORT ZONE -SUNWAY MONT- MONT KIARA/11-full-1.jpg" alt="">
        </b-col>
      </b-row>
      <b-row sm>
        <b-col md="6" sm>
          <img src="../../../assets/img/works/link-house-condo/02-舒窝 -COMFORT ZONE -SUNWAY MONT- MONT KIARA/12-land-1.jpg" alt="">
        </b-col>
        <b-col md="6" sm>
          <img src="../../../assets/img/works/link-house-condo/02-舒窝 -COMFORT ZONE -SUNWAY MONT- MONT KIARA/12-land-2.jpg" alt="">
        </b-col> 
      </b-row>
      <b-row sm>
        <b-col>
          <img src="../../../assets/img/works/link-house-condo/02-舒窝 -COMFORT ZONE -SUNWAY MONT- MONT KIARA/13-full-1.jpg" alt="">
        </b-col>
      </b-row>
      <b-row sm>
        <b-col md="4" sm>
          <img src="../../../assets/img/works/link-house-condo/02-舒窝 -COMFORT ZONE -SUNWAY MONT- MONT KIARA/14-land-1.jpg" alt="">
        </b-col>
        <b-col md="4" sm>
          <img src="../../../assets/img/works/link-house-condo/02-舒窝 -COMFORT ZONE -SUNWAY MONT- MONT KIARA/14-land-2.jpg" alt="">
        </b-col>
        <b-col md="4" sm>
          <img src="../../../assets/img/works/link-house-condo/02-舒窝 -COMFORT ZONE -SUNWAY MONT- MONT KIARA/14-land-3.jpg" alt="">
        </b-col>
      </b-row>
      <b-row sm>
        <b-col md="6" sm>
          <img src="../../../assets/img/works/link-house-condo/02-舒窝 -COMFORT ZONE -SUNWAY MONT- MONT KIARA/15-portrait-1.jpg" alt="">
        </b-col>
        <b-col md="6" sm>
          <img src="../../../assets/img/works/link-house-condo/02-舒窝 -COMFORT ZONE -SUNWAY MONT- MONT KIARA/15-portrait-2.jpg" alt="">
        </b-col>
      </b-row>
      <b-row sm>
        <b-col md="4" sm>
          <img src="../../../assets/img/works/link-house-condo/02-舒窝 -COMFORT ZONE -SUNWAY MONT- MONT KIARA/16-land-1.jpg" alt="">
        </b-col>
        <b-col md="4" sm>
          <img src="../../../assets/img/works/link-house-condo/02-舒窝 -COMFORT ZONE -SUNWAY MONT- MONT KIARA/16-land-2.jpg" alt="">
        </b-col>
        <b-col md="4" sm>
          <img src="../../../assets/img/works/link-house-condo/02-舒窝 -COMFORT ZONE -SUNWAY MONT- MONT KIARA/16-land-3.jpg" alt="">
        </b-col>
      </b-row> 
    </div>
    <div class="container p-112 works-img">
      <b-row >
        <b-col md="4" class="pb-24"> 
          <b-row class="flex-center">
            <b-col cols="3" to="Mu"  tag="router-link"><img class="icon-expand cursor-pointer" src="../../../assets/img/icon/expand_circle_left_white.svg"></b-col>
            <b-col cols="9" class="text-right">
              <p class="inter inter-body-md-600 white  p-0">PREVIOUS PROJECT</p>
              <p class="playfair playfair-title-lg-400 white p-0">沐光 | Mu</p>
              <p class="inter inter-body-md-400 white p-0">Taman Cantik | Kuala Lumpur</p>
            </b-col> 
          </b-row>
        </b-col>
        <b-col md="4" sm> 
        </b-col>
        <b-col md="4" sm> 
          <b-row class="flex-center">
            <b-col cols="9" class="text-left">
              <p class="inter inter-body-md-600 white  p-0">NEXT PROJECT</p>
              <p class="playfair playfair-title-lg-400 white p-0">岩灰 | Grey Song</p>
              <p class="inter inter-body-md-400 white p-0">Kiaraville | Mont Kiara</p>
            </b-col>
            <b-col cols="3"  to="Grey-Song"  tag="router-link"><img class="icon-expand cursor-pointer" src="../../../assets/img/icon/expand_circle_right_white.svg" alt=""></b-col>
          </b-row>
          
        </b-col>
      </b-row>
    </div>
  </div>

</template>

<script>
export default {
  name: 'comfortZone',
  data() {
    return { 
    }
  },
  methods: { 
  }, 

}
</script>

<style>
 
.comfort-zone{
  background-color: #7F7F7F !important;
}
.banner img, .works-img img{
  width: 100%;
}
.works-img img{
  padding-bottom: 24px;
}
.comfort-zone p {
  padding: 24px 0;  
}
.p-112{
  padding: 112px 0 88px;
}
.works-component .amalfi-coast-title {
  padding-bottom: 4rem;
}

.letter-spacing {
  letter-spacing: 0.5em;
  padding-bottom: 56px
}
img.icon-expand{
  width: auto;
}

@media (max-width: 576px) { 
}
</style>